import { render, staticRenderFns } from "./overdueSupplyReviewApproval.vue?vue&type=template&id=f85cde12&scoped=true"
import script from "./overdueSupplyReviewApproval.vue?vue&type=script&lang=js"
export * from "./overdueSupplyReviewApproval.vue?vue&type=script&lang=js"
import style0 from "./overdueSupplyReviewApproval.vue?vue&type=style&index=0&id=f85cde12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85cde12",
  null
  
)

export default component.exports